<template>
  <div>
    <div class="d-flex align-items-start">
      <span class="mr-10">From</span>
      <DatePicker
        label=""
        position="relative"
        v-model="start"
        placeholder="Select date"
        :custom="true"
      />
    </div>
    <div class="d-flex align-items-start">
      <span class="mr-30">To</span>
      <DatePicker
        label=""
        position="relative"
        v-model="end"
        placeholder="Select date"
        :custom="true"
      />
    </div>
    <ActionButton
      @customEvent="handleDateSubmit"
      label="Submit"
      :theme="{
        primary: currentScheme.primary,
        secondary: currentScheme.secondary,
        event: currentScheme.event,
        danger: currentScheme.danger
      }"
      style="width: auto; margin: 0 0 0 auto;"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/datetimepicker/DatePicker";
import ActionButton from "@/components/ActionButton";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SelectDate",
  components: {
    DatePicker,
    ActionButton
  },
  data: () => ({
    start: moment().format("MMM DD, YYYY"),
    end: moment().format("MMMM DD, YYYY")
  }),
  computed: {
    ...mapGetters({
      currentScheme: "currentScheme"
    })
  },
  methods: {
    ...mapActions({
      updateCustomDateRange: "updateCustomDateRange"
    }),
    handleDateSubmit() {
      this.updateCustomDateRange({
        start: this.start,
        end: this.end
      });
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
